/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BulkGetUserFavoriteGachasRequest } from '../../models/bulk-get-user-favorite-gachas-request';
import { BulkGetUserFavoriteGachasResponse } from '../../models/bulk-get-user-favorite-gachas-response';

export interface UserServiceBulkGetUserFavoriteGachas$Params {
      body: BulkGetUserFavoriteGachasRequest
}

export function userServiceBulkGetUserFavoriteGachas(http: HttpClient, rootUrl: string, params: UserServiceBulkGetUserFavoriteGachas$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkGetUserFavoriteGachasResponse>> {
  const rb = new RequestBuilder(rootUrl, userServiceBulkGetUserFavoriteGachas.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BulkGetUserFavoriteGachasResponse>;
    })
  );
}

userServiceBulkGetUserFavoriteGachas.PATH = '/api/v3/gateway/bulk/user/gacha';
